(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-spotlight-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    const galleries = document.querySelectorAll('[data-ps-gallery]');
    galleries.forEach((g) => {
      if (g.dataset.psGalleryBound) return;
      g.dataset.psGalleryBound = '1';
      const thumbs = g.querySelectorAll('.ps-gallery__thumb[data-thumb-index]');
      const images = g.querySelectorAll('.ps-gallery__main-image');
      if (!thumbs.length || !images.length) return;
      thumbs.forEach((t) => {
        t.addEventListener('click', () => {
          const i = t.getAttribute('data-thumb-index');
          thumbs.forEach((x) => {
            const a = x.getAttribute('data-thumb-index') === i;
            x.classList.toggle('is-active', a);
            x.setAttribute('aria-selected', a ? 'true' : 'false');
          });
          images.forEach((img) => {
            img.classList.toggle('is-active', img.getAttribute('data-image-index') === i);
          });
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-spotlight-quantity"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.psQuantityBound) return;
    window.psQuantityBound = true;

    const clamp = (input) => {
      const step = Number(input.step) || 1;
      const min = Number(input.min) || 1;
      const max = input.max === '' ? null : Number(input.max);
      let value = Number(input.value);

      if (!Number.isFinite(value)) value = min;
      if (value < min) value = min;

      const steps = Math.round((value - min) / step);
      value = min + steps * step;

      if (max !== null && value > max) value = max - ((max - min) % step);
      if (value < min) value = min;

      input.value = String(value);
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-ps-qty-step]');
      if (!button) return;

      const wrapper = button.closest('[data-ps-qty]');
      const input = wrapper && wrapper.querySelector('.ps-qty__input');
      if (!input) return;

      const step = Number(input.step) || 1;
      input.value = String(Number(input.value || 0) + step * Number(button.dataset.psQtyStep));
      clamp(input);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    document.addEventListener('change', (event) => {
      const input = event.target;
      if (input.classList && input.classList.contains('ps-qty__input')) clamp(input);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
